import Axios from "axios";

const ImageProductService = {
  async uploadImage(data) {
    try {
      const res = await Axios.post("/images/upload", data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return res.data;
    } catch (err) {
      throw err.response.data;
    }
  },
  async uploadImageTwo(data) {
    try {
      const res = await Axios.post("/images/upload/two", data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return res.data;
    } catch (err) {
      throw err.response.data;
    }
  },
  async findAll(data) {
    try {
      const res = await Axios.post("/images/all", data);
      return res.data;
    } catch (err) {
      throw err.response.data;
    }
  },
  async delete(params) {
    try {
      const res = await Axios.post("/images/delete", params);
      return res.data;
    } catch (err) {
      throw err.response.data;
    }
  },
  async deleteAll(params) {
    try {
      const res = await Axios.post("/images/delete-all", params);
      return res.data;
    } catch (err) {
      throw err.response.data;
    }
  },
  async searchIdemp(params) {
    try {
      const res = await Axios.post("/images/search/idemp", params);
      return res.data;
    } catch (err) {
      throw err.response.data;
    }
  },
};

export default ImageProductService;
